export const getProductDetailsFromElement = <T extends Element>(element: T) => {
  const productToken = element.getAttribute("data-product-token") ?? "";
  const promotedBy = element.getAttribute("data-product-promoted-by") ?? "";
  const impressionId = element.getAttribute("data-product-impression-id") ?? "";
  const settingsToAssignOnView = element
    .getAttribute("data-settings-to-assign-on-view")
    ?.split(",");

  return { productToken, promotedBy, impressionId, settingsToAssignOnView };
};
